import {
  getMappedPropertyReviewContext,
  getOfferPropertyReviewContext,
  type ReviewContext,
} from 'components/OfferPage/NavigableOfferContent/reviewContext'
import type { DrawerAccommodationDetailsSource } from './useDrawerAccommodationDetailsSource'

export default function getDrawerReviewContext(
  source: DrawerAccommodationDetailsSource,
): ReviewContext | undefined {
  if (source.kind === 'flash') {
    return getOfferPropertyReviewContext(source.offer?.property, 'luxuryescapes')
  }

  if (source.kind === 'bedbank') {
    return getOfferPropertyReviewContext(source.offer?.property, 'bedbank')
  }

  if (source.kind === 'property' && source.property && source.mapping) {
    return getMappedPropertyReviewContext(source.property, source.mapping)
  }
}
